import React from 'react';

interface RoundImageProps {
    src: string;
    alt: string;
    style?: React.CSSProperties;
}

export const RoundImage: React.FC<RoundImageProps> = ({ src, alt, style }) => <img src={src} alt={alt} style={style} />;
